<!--  -->
<template>
  <div>
    <section class="feature-course-section">
        <div class="container">
            <div class="row">
                <div class="col-md-5">
                    <h2 class="sec-title"><span>为你找到合适的在线课程</span></h2>
                </div>
                <div class="col-md-7">
                    <ul class="shaf-filter">
                         <li  data-group="development" v-for="(courcate,index) in courcates" :key="index" :class="catesel==courcate?'active':''"  @click="chgcourcate(courcate)">{{courcate}}</li>
                    </ul>
                </div>
            </div>
            <div class="row shafull-container" v-if="courses&&courses.length>0">
                <div class="col-lg-4 col-md-6 shaf-item"  v-for="(course,index) in courses" :key="index">
                    <div class="feature-course-item-3">
                    <div class="fcf-thumb">
                            <img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt="">
                        <router-link class="enroll"  :to="`/courview/info/${course._id}`">{{course.isBuy==1? '立即学习':course.isBuy==0?'报名学习':course.isBuy==3?'未开始':'已到期'}}</router-link>
                    </div>
                    <div class="fci-details">
                        <a href="#" class="c-cate"><i class="icon_tag_alt"></i>{{course.spltip}}</a>
                        <h4> <router-link :to="`/courview/info/${course._id}`">{{course.title}}</router-link></h4>
                        <div class="author">
                            <img src="/static/images/home3/course/a1.png" alt="">
                            <a href="#">{{course.author}}</a>
                        </div>
                        <div class="price-rate">
                            <div class="course-price">
                                    {{course.students?course.students:0}}人报名
                            </div>
                            <div class="ratings">
                                <el-rate
                                v-if="course.stars"
                                :value="course.stars"
                                disabled
                                show-score
                                text-color="#ff9900"
                                :score-template="parseFloat(course.stars).toFixed(1)">
                            </el-rate>
                            <span v-else>暂无评分</span>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
               
            </div>
             <el-card  v-else  class="box-card">
                  <el-empty description="暂无相关课程"></el-empty>
              </el-card>
              <div class="row">
                <div class="col-md-12 text-center">
                    <router-link  to="/courviews" class="read-more">所有课程<i class="arrow_right"></i></router-link>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      catesel: "",
      courcates: [
          "最新",
          "评分最高",
          "最受欢迎",
          "销量最高"
      ],
      courses: [],
      global,
    };
  },

  components: {},

  computed: {},

  mounted() {
    let strextra="";
    if(this.$root.onlymycourse)
    {
      strextra="&type[in]="+ this.$root.hasCourse;
    }
    this.$axios
      .get("/api/courses/visitor?page=1&limit=6&sort=-createdAt"+strextra)
      .then((res) => {
        if (res.data) {
          this.courses = res.data.data;
          
        }
      });
  },

  methods: {
    chgcourcate(cate) {
      this.catesel = cate;
       let strextra="";
      if(this.$root.onlymycourse)
      {
        strextra="&type[in]="+ this.$root.hasCourse;
      }
      
      if(cate!="最新"){
        strextra+="&spltip="+cate;
      }
      this.$axios
      .get("/api/courses/visitor?page=1&limit=6&sort=-createdAt"+strextra)
      .then((res) => {
        if (res.data) {
          this.courses = res.data.data;
          this.$forceUpdate();
        }
      });
    },
  },
};
</script>
<style scoped>
.course-block .course-item .course-img .course__img img {
  width: 100%;
  height: 246.66px;
  -webkit-border-radius: 4px 4px 0 0;
  -moz-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
}
</style>
